module.exports = __webpack_public_path__ + "img/VillaLoreto_Resor3t.b12b46d6.jpg";